

const router_modular = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'landingPage',
        component: () => import('@/views/landingPage.vue')
    },
    {
        path: '/bankPage',
        name: 'bankPage',
        component: () => import('@/views/bankPage/index.vue')
    },
    {
        path: '/bankDetailsPage',
        name: 'bankDetailsPage',
        component: () => import('@/views/bankPage/bankDetailsPage.vue')   
    },
    {
        path: '/uploadCredentials',
        name: 'uploadCredentials',
        component: () => import(/* webpackChunkName: "uploadCredentials" */ '@/views/uploadCredentials/index.vue')
    },
    {
        path: '/enterInformation',
        name: 'enterInformation',
        component: () => import(/* webpackChunkName: "enterInformation/index.vue" */ '@/views/enterInformation/index.vue')
    },
    {
        path: '/repaymentResult',
        name: 'repaymentResult',
        component: () => import(/* webpackChunkName: "repaymentResult/index.vue" */ '@/views/repaymentResult/index.vue')
    },
    {
        path: '/commitRecord',
        name: 'commitRecord',
        component: () => import(/* webpackChunkName: "commitRecord/index.vue" */ '@/views/commitRecord/index.vue')
    },
    {
        path: '/about_us',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index.vue')
    },
]
export default router_modular